import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Input,
  Select,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Heading,
  Box,
  Image,
  Spinner,
} from "@chakra-ui/react";
import thelogo from "../../../assets/thelogo.png"
import { getFollowingUsers } from "../../../pages/dashboard/discover/service";
import { useNavigate } from "react-router-dom";

const FollowersModal = ({ isOpen, onClose, authUserId, myFollowers, handleFollow }) => {
  //sconsole.log("userid-->", authUserId);

  const [allFollowers, setAllFollowers] = useState([]); //unused
  const [loading, setLoading] = useState(true); //unused

  const containerBgColor = useColorModeValue("#fff", "#000216");
  const inputBgColor = useColorModeValue("#F9FAFC", "rgba(6, 119, 232, 0.2)"); 

  const navigate = useNavigate();

  const inputStyles = {
    p: "5px",
    borderRadius: "5px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    color: "rgba(6, 119, 232, 1)",
    w: "15%",
    //color: "#697C94",
    // h: "2em"
  };

  const btnStyle = {
    p: "5px 10px",
    alignItems: "center",
    borderRadius: "5px",
    color: "#fff",
    direction: "row",
    cursor: "pointer",
    w: "30%"
  };

  
  //console.log('setmyFollowers: ', myFollowers)

  const handleTheFollow = (userIdToRemove) => {
    handleFollow(userIdToRemove)
    //onClose();
  }

  return (
    <>
    
    <Modal isOpen={isOpen} onClose={onClose} size="lg" scrollBehavior="inside">
      
        <ModalOverlay />
        <ModalContent bg={containerBgColor}>
          <ModalHeader>
            
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          <Flex justifyContent="center" alignItems="center" mb={"2em"}>
            <Heading fontSize={"1.5em"}>Followers</Heading>
          </Flex>
          
          {myFollowers?.length > 0 ? 
          (myFollowers?.map((user, index) => (
            <Flex justifyContent="space-between" alignItems="center" mb={"2em"} key={index}>
                <Stack>
                {/* Content for the left side */}
                <Flex alignItems="center">
                    <Image
                    fallbackSrc={thelogo} // Provide a fallback image source
                    src={user?.picture} // Replace with the actual image source
                    alt={user?.name} // Replace with the actual alt text
                    boxSize="50px"
                    borderRadius="50%"
                    />
                    <Text ml="2"
                    onClick={() => {
                      navigate(`/view-profile/${user?.id}`);
                    }}
                    >{user?.name}</Text>
                </Flex>
                </Stack>

                <Box
                    textAlign={"center"}
                    {...inputStyles}
                    cursor={"pointer"}
                    onClick={() => handleTheFollow(user?.id)}
                >
                    Follow
                </Box>
            </Flex>
          ))) : (
            <Flex justifyContent="center" alignItems="center" mb={"2em"}>
                <Spinner size="xl" color="blue.500" />
            </Flex>
            
          )
        }

          

          </ModalBody>
        </ModalContent>
    </Modal>
    
    </>
  )
}

export default FollowersModal